import { Html, MultiLineText, SingleSelect, Text } from 'Shared/forms/Inputs'
import { Wrap } from 'Shared/forms/Wrap'
import { usePage } from 'Shared/frontend/PageProvider';
import { VenueUrls } from 'Common/VenueUrls';
import { tabStyle } from 'Shared/backend/contact/ContactPage';
import { css } from '@emotion/css';
import { theme } from 'Shared/backend/ThemeProvider';



export function GeneralTab(props)
{
	const page = usePage();
	const urls = new VenueUrls(page.build,page.site.key);

	const htmlOptions = {
		height: 200,
		menubar: false,
		promotion: false,
		plugins: ['link'],
		statusbar: false,
		toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | link'
	};

	return (
		<div class={tabStyle()}>
			<Wrap label='Venue name'>
				<Text {...props} field='name' />
			</Wrap>

			<Wrap label='Venue Nick Name (optional)' 
				notes='Often a shorter, affectionate name used by regular patrons, will be used on marketing'
			>
				<Text {...props} field='nickname' />
			</Wrap>

			<Wrap label='Street address'>
				<Text {...props} field='streetAddress' />
			</Wrap>

			<Wrap label='Suburb'>
				<Text {...props} field='suburb' />
			</Wrap>

			<Wrap label='Postcode'>
				<Text {...props} field='postcode' />
			</Wrap>

			<Wrap label='State/Territory' required={true}>
				<SingleSelect {...props} field='state' options={{
					'act':'ACT','nsw':'NSW','nt':'NT','qld':'QLD','sa':'SA','tas':'TAS','vic':'VIC','wa':'WA'
				}} />
			</Wrap>

			{/* TODO Ben (low priority), set default option to Australia See inputs.njk file for initial value */}
			<Wrap label='Country' required={true}>
				<SingleSelect {...props} field='country' options={{
					'aus':'Australia','usa':'USA','uk':'UK'
				}} />
			</Wrap>

			<Wrap label='Postal address (leave blank if same as street address)'>
				<Text {...props} field='postalAddress' />
			</Wrap>

			<Wrap label='Main phone number'>
				<Text {...props} field='phoneNumber' />
			</Wrap>

			<Wrap label='ABN'>
				<Text {...props} field='abn' />
			</Wrap>

			<Wrap label='ACN'>
				<Text {...props} field='acn' />
			</Wrap>

			{/* TODO create a global Embed code fieldType? */}
			<Wrap label='URL to open Google Map'>
				<Text {...props} field='mapUrl' />
			</Wrap>


			{/* TODO create a global Embed code fieldType? */}
			<Wrap label='Embed code for Google Map'>
				<MultiLineText {...props} field='mapEmbed' numRows={10} />
			</Wrap>

			<h3 class={css(theme().section.blueHeading)}>COMING SOON: EVENT BOOKING TEMPLATES</h3>

			<Wrap label={<h4>Venue Event Contacts</h4>}>
				<Html {...props} field='venueEventContacts_Template' options={htmlOptions} urls={urls} />
			</Wrap>

			<Wrap label={<h4>Load in and out</h4>}>
				<Html {...props} field='loadInOut_Template' options={htmlOptions} urls={urls} />
			</Wrap>

			<Wrap label={<h4>Performance Terms</h4>}>
				<Html {...props} field='performanceTerms_Template' options={htmlOptions} urls={urls} />
			</Wrap>

			<Wrap label={<h4>Worksheet Terms</h4>}>
				<Html {...props} field='worksheetTerms_Template' options={htmlOptions} urls={urls} />
			</Wrap>

			<Wrap label={<h4>Payment Terms</h4>}>
				<Html {...props} field='paymentTerms_Template' options={htmlOptions} urls={urls} />
			</Wrap>

			<Wrap label={<h4>Other Terms</h4>}>
				<Html {...props} field='otherTerms_Template' options={htmlOptions} urls={urls} />
			</Wrap>
		</div>
	);
}
